import React, { useEffect, useState } from "react";
import CreatePasswordView from "./CreatePasswordView";
import { useTranslation } from "react-i18next";
import crmservices from '../../wsclient';
import { useNavigate } from "react-router-dom";
import { config_path } from "../../router/config.path";

export default function CreatePasswordController(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showProcessing, setShowProcessing] = useState(false);
    const [message, setMessage] = useState(null);
    const [key, setKey] = useState(null);
    const [validations, setValidations] = useState(null);

    useEffect(() => {
        onLoad();
    },[]);

    const onLoad = () => {
        let url = window.location.href;
        let queryParams = window.location.search;
        console.log("AAAA onLoad queryParams: ", queryParams);
        let key = getQueryParamValue("key");
        console.log("AAAA onLoad key: ", key);
        setKey(key);
    }

    const onValidateFields = (values) => {
        let valid = true;
        let { password, confirm_password } = values;
        if(password && confirm_password && (password !== confirm_password)){
            valid = false;
            showMessage({ status: true, message: t('PASSWORD_NOT_MATCH') });
        }
        return valid;
    }

    const onSubmit = async (values) => {
        console.log("AAAA onSubmit values: ", values);
        console.log("AAAA onSubmit key: ", key);
        let isValid = onValidateFields(values);
        if(!isValid) return false;
        setShowProcessing(true)
        try {
            let result = await crmservices.authentication.acceptInvite({
                token: key,
                password: values.password,
            });
            console.log("AAAA onSubmit result: ", result);
            if(result.code == 'OK') {
                setValidations(null);
                showMessage({ status: true, message: t('CREATE_PASSWORD_SUCCESS'), callBackFn: () => navigate(config_path.login) });
            } else {
                let message = result.data && result.data.message ? result.data.message : null;
                let parameters = result.data && result.data.parameters ? result.data.parameters : [];
                let password_rules = result.data && result.data.password_rules ? result.data.password_rules : [];
                setValidations({
                    message: message,
                    is_valid: false,
                    parameters: parameters,
                    password_rules: password_rules,
                })
            }
        } catch (error) {
            console.log("AAAA onSubmit error: ", error);
            showMessage({ status: true, message: t('EXCEPTION_PROCESS' )})
        }
        setShowProcessing(false)
    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowProcessing(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }

    const getQueryParamValue = (queryParamKey) => {
		let queryParams = {};
		let queryParamsString = window.location.search;
		if(queryParamsString!== undefined)
		{
			if(queryParamsString.startsWith("?"))
			{
				queryParamsString = queryParamsString.slice(1);
			}
			queryParamsString.split("&").forEach(queryParam => {
				let params = queryParam.split("=");
				queryParams[params[0]] = params[1];
			});
		}
		let param = queryParams[queryParamKey];
		if(param)
		{
			param = decodeURIComponent(param).trim();
		}
		return param;
	};

    return(
        <>
            <CreatePasswordView 
                showProcessing={showProcessing}
                message={message}
                validations={validations}
                onSubmit={onSubmit}
            />
        </>
    )
}